import { EppoFeatureFlagsWithJson } from "app/types/flags";
import { useFeatureFlagVariation } from "shared/hooks/useEppoFeatureFlagVariation";
import { useHubSlug } from "shared/hooks/useHubSlug";

type RawBagType = {
  key: string;
  minimum_value: number;
  maximum_threshold: number;
  sku?: string;
  maximum_units_per_sku?: number;
  minimum_distinct_skus?: number;
  allowed_categories?: string[];
  excluded_categories?: string[];
};

export type BagType = {
  key: string;
  minimumValue: number;
  maximumThreshold: number;
  sku?: string;
  maximumUnitsPerSku: number | null;
  minimumDistinctSkus: number | null;
  allowedCategories: string[];
  excludedCategories: string[];
};

export type BagTypes = Array<BagType> | null;

export const useBagTypesFeatureFlag = () => {
  const hubSlug = useHubSlug();
  const response = useFeatureFlagVariation(
    hubSlug!,
    EppoFeatureFlagsWithJson.TOO_GOOD_TO_GO_BAG_TYPES,
  );

  const rawBagTypes = response?.bag_types as Array<RawBagType> | null;

  const bagTypes: BagTypes =
    rawBagTypes?.map((bag) => ({
      key: bag.key,
      minimumValue: bag.minimum_value,
      maximumThreshold: bag.maximum_threshold,
      sku: bag.sku,
      maximumUnitsPerSku: bag.maximum_units_per_sku ?? null,
      minimumDistinctSkus: bag.minimum_distinct_skus ?? null,
      allowedCategories: bag.allowed_categories ?? [],
      excludedCategories: bag.excluded_categories ?? [],
    })) ?? null;

  return {
    bagTypes,
  };
};
